import { ZoomVideoSdkUser, ZoomVideoSdkUserType } from './ZoomVideoSdkUser';

export type ZoomVideoSdkChatMessageType = {
  /**
   * The message content.
   */
  content: string;

  /**
   * The receiving user.
   */
  receiverUser?: ZoomVideoSdkUserType;

  /**
   * The sender user.
   */
  senderUser: ZoomVideoSdkUserType;

  /**
   * Time stamp of the transcription message.
   */
  timestamp: number;

  /**
   * The message is send by me or not.
   */
  isSelfSend: boolean;

  /**
   * The message is send to all users or not.
   */
  isChatToAll: boolean;

  /**
   * The message ID of the transcription message.
   */
  messageID: string;
};

export class ZoomVideoSdkChatMessage implements ZoomVideoSdkChatMessageType {
  content;
  receiverUser;
  senderUser;
  timestamp;
  isSelfSend;
  isChatToAll;
  messageID;

  constructor(chatMessage: ZoomVideoSdkChatMessageType) {
    this.content = chatMessage.content;
    this.receiverUser = chatMessage.receiverUser
      ? new ZoomVideoSdkUser(chatMessage.receiverUser)
      : undefined;
    this.senderUser = new ZoomVideoSdkUser(chatMessage.senderUser);
    this.timestamp = chatMessage.timestamp;
    this.isSelfSend = chatMessage.isSelfSend;
    this.isChatToAll = chatMessage.isChatToAll;
    this.messageID = chatMessage.messageID;
  }
}
